import { useMemo } from 'react';
import type { StepId } from '@hotjar/webapp/features/Activation/GetStartedGuide/types';
import * as gettingStartedGuide from '@hotjar/webapp/domains/activation/getting-started-guide';
import { useCurrentSite } from '@hotjar/site';
import { useCurrentUser } from '@hotjar/user';

interface GSGFunctions {
  // eslint-disable-next-line @typescript-eslint/no-explicit-any
  init: () => Promise<any>;
  markAsCompleted: () => void;
  markAsCelebrated: () => void;
  markStepAsCompleted: (stepId: StepId) => void;
  markRecordingAsSeen: () => void;
}

export const useGettingStartedGuide = (): GSGFunctions => {
  const { data: currentSite } = useCurrentSite();
  const { data: currentUser } = useCurrentUser();
  const userId = currentUser?.id;

  return useMemo(() => {
    return {
      init: () => gettingStartedGuide.init(currentSite, userId),
      markAsCompleted: () => gettingStartedGuide.complete(currentSite, userId),
      markAsCelebrated: () => gettingStartedGuide.markAsCelebrated(currentSite, userId),
      markStepAsCompleted: (stepId: StepId) =>
        gettingStartedGuide.markStepAsCompleted(stepId, currentSite, userId),
      markRecordingAsSeen: () => gettingStartedGuide.markRecordingAsSeen(currentSite, userId),
    };
    // We use currentSite id so we don't cause re-renders if a new ref
    // to currentSite is provided with the same id
  }, [currentSite?.id, userId]); // eslint-disable-line react-hooks/exhaustive-deps
};
